import { FormCategory } from "types";

export const defaultFormTemplates: {
  name: string;
  categories: FormCategory[];
}[] = [
  {
    name: "Compte-rendu de chantier",
    categories: [
      {
        id: "cat_prep",
        name: "Travaux préparatoires",
        fields: [
          {
            id: "field_parcelle",
            label: "Identification de la parcelle",
            type: "checkbox",
            value: false,
          },
          {
            id: "field_panneau",
            label: "Mise en place du panneau de chantier",
            type: "checkbox",
            value: false,
          },
          {
            id: "field_cloture",
            label: "Clôture de chantier installée",
            type: "checkbox",
            value: false,
          },
        ],
      },
      {
        id: "cat_alti",
        name: "Altimétrie",
        fields: [
          {
            id: "field_dalle_edf",
            label: "Niveau de la dalle brute par rapport au coffret EDF",
            type: "text",
            value: "",
          },
          {
            id: "field_dalle_eu",
            label: "Niveau de la dalle brute par rapport au réseau EU",
            type: "text",
            value: "",
          },
        ],
      },
      {
        id: "cat_observations",
        name: "Observations",
        fields: [
          {
            id: "field_obs",
            label: "Observations générales",
            type: "text",
            value: "",
          },
        ],
      },
    ],
  },
  {
    name: "Réception de chantier",
    categories: [
      {
        id: "cat_verif",
        name: "Vérifications générales",
        fields: [
          {
            id: "field_conformite",
            label: "Conformité aux plans",
            type: "checkbox",
            value: false,
          },
          {
            id: "field_proprete",
            label: "Propreté du chantier",
            type: "checkbox",
            value: false,
          },
          {
            id: "field_securite",
            label: "Sécurité conforme",
            type: "checkbox",
            value: false,
          },
        ],
      },
      {
        id: "cat_reserves",
        name: "Réserves",
        fields: [
          {
            id: "field_nb_reserves",
            label: "Nombre de réserves",
            type: "number",
            value: 0,
          },
          {
            id: "field_detail_reserves",
            label: "Détail des réserves",
            type: "text",
            value: "",
          },
          {
            id: "field_delai",
            label: "Délai de levée des réserves",
            type: "select",
            value: "",
            options: ["7 jours", "15 jours", "30 jours", "60 jours"],
          },
        ],
      },
      {
        id: "cat_decision",
        name: "Décision",
        fields: [
          {
            id: "field_decision",
            label: "Décision de réception",
            type: "select",
            value: "",
            options: [
              "Réception sans réserve",
              "Réception avec réserves",
              "Refus de réception",
            ],
          },
        ],
      },
    ],
  },
];
